export const applicantInstructions = {
    startingParagraphs: [
        "To complete your application later just click on the save button at the bottom to return and finish at a later time.",
        "For updates on your application status please text us at 251-577-4036",
        "Your application will not be processed until completed.",
        "Minimum Requirements for Approval:"
    ],
    dotLi: [
        "Each adult that will be living in the home must be fill out an application;",
        "The total household monthly net income must be over 3 times the rent;",
        "All adults must have no evictions in the last 5 years, pass a background check, and have a good rental history if they are currently renting;",
        "Have a minimum credit score of 600."
    ],
    dashLi: [
        "we must have recent check stubs within the last 60 days",
        "The total household monthly net income must be over 3 times the rent;",
        "All adults must have no evictions in the last 5 years, pass a background check, and have a good rental history if they are currently renting;",
        "cosigners income must be 3 times the rent after subtracting their personal expense and debts."
    ],
    endingParagraphs: [
        "Please be prepared to pay the application fee as outlined in the property listing. In addition to this rental application, you will also be required to provide a copy of a valid form of identification and proof of income.",
        "To complete this rental application, you must be prepared to provide 3 years of residential history as well as contact information for your rental references. You will also be asked to provide information on your monthly income, and please note that most properties require that applicant combined NET income is at least three (3) times the monthly rent amount.",
        "Each resident over the age of 18 must fill out an application.",
        "PET/ANIMAL SCREENING IS A REQUIRED PART OF THE APPLICATION PROCESS FOR ALL APPLICANTS: There is no cost for households with no pets or with service animals.",
        "A welcoming environment is paramount to all of our residents. To help ensure ALL of our residents understand our pet and animal-related policies, we use a third-party screening service and require EVERYONE to complete a profile (No Pet/Pet/Animal). This process ensures we have formalized pet and animal-related policy acknowledgments and more accurate records to create greater mutual accountability. If you need accommodation in another way, please contact your housing provider. We are not able to accept pit bulls and similar dog breeds. We have a 2 pet/animal maximum at each property. There is a $25/month pet fee for approved pets, with no additional deposit. Each property listing indicates if pets are accepted or not accepted the property.",
        "The Non-Refundable application fee is $45 per adult and must be paid when submitting this application.",
        "When your application is approved there will be a $75 Lease Prep fee due at the signing of the lease.",
        "As a company we obey the Fair Housing Act. We do not discriminate against any person because of Race, Color, Religion, Sex, Handicap, Familial Status, or National Origin.",
        "All tenants are required to sign up for the Resident Benefit Package at a cost of $13 per month and provide proof of their own renters insurance and name Integrity Oklahoma as Additionally Insured. The insurance fee will be separate from the $13 benefit fee.  If the tenant does not provide proof of insurance they will be enrolled in our renters insurance policy for a fee of approx. $12 per month as outlined in the lease.",
        "Some properties qualify for the $0 Security Deposit program.  With this program you would pay an Admin fee of $50 at move in and sign up for a plan with SayRhino.com.  They would then bill you a small monthly fee based on your credit score.  Fees can be as low as $15 per month.  This can be much cheaper than paying a full deposit at move in!",
    ],
    approvedFasterCriteria: [
        "make sure all adults in your household have applied",
        "make sure and view the home in person",
        "make sure and turn in proof of income or tax returns (this must be an official document)",
        "make sure and provide a phone number and email address for all landlords",
    ],
    applicationFee:[
        {
            price: "45.00"
        }
    ]
}

export const emailGuide = `
We'll Put
Your Logo Here	Company Name 
Company Address
Company Phone Number | Company Website

Dear Owner Name, 
We invite you to access your Owner Portal.

In Your Owner Portal, You Can:

Monthly Statements	View Your Monthly Statements
Inspections Documents	Access Inspection Reports & Documents
Owner Contributions	Make Secure Monetary Contributions to Your Properties

Activate Now

After clicking “Activate Now,” please follow these steps below to gain access to your personalized information:

Steps to Activate:

1	Enter your email address that this email was sent to.
2	Click "Sign up.” You will then receive an activation email.
3	Check your inbox for the activation email. You will need to confirm your email address and set a password.
Benefits:

Secure - All of your documents stored in one place.
Convenient - Easily view your monthly statements and critical documents at any time.
Effortless - No need to dig through your email or find a paper statement.

For the best experience, please use Chrome or Safari browsers. 
Please let us know if you have any questions.


Company Name
Company Phone Number
Company Website
Company Address`;
